import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import { FormattedMessage } from 'react-intl';

import { ProgressIndicator, Step } from '../components/ProgressIndicator';

export const FundingProgressIndicator = ({ step }: { step: number }) => {
    const { data } = useGetAccounts();

    const isTopup = data?.accounts?.some(
        (acc) => acc.loan_status && acc.loan_status !== 'ended'
    );

    const STEPS_CONFIG = [
        {
            id: 1,
            label: 'Application',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.application"
                    defaultMessage="Application"
                />
            )
        },
        {
            id: 2,
            label: 'Provide documents',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.provide_documents"
                    defaultMessage="Provide documents"
                />
            )
        },
        {
            id: 3,
            label: isTopup ? 'Select amount' : 'Configure loan',
            message: isTopup ? (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.select_amount"
                    defaultMessage="Select amount"
                />
            ) : (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.configure_loan"
                    defaultMessage="Configure loan"
                />
            )
        },
        {
            id: 4,
            label: 'Final checks',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.final_checks"
                    defaultMessage="Final checks"
                />
            )
        },
        {
            id: 5,
            label: 'Withdraw funds',
            message: (
                <FormattedMessage
                    id="_.funding_progess_indicator.label.withdraw_funds"
                    defaultMessage="Withdraw funds"
                />
            )
        }
    ];

    return (
        <ProgressIndicator>
            {STEPS_CONFIG.map(({ id, label, message }) => (
                <Step
                    key={id}
                    label={label}
                    message={message}
                    className={
                        label === 'Provide documents'
                            ? 'min-sm:basis-s'
                            : undefined
                    }
                    status={
                        step === id
                            ? 'active'
                            : step > id
                              ? 'complete'
                              : 'pending'
                    }
                />
            ))}
        </ProgressIndicator>
    );
};
